import { render, staticRenderFns } from "./PeopleRegistration.vue?vue&type=template&id=51de8df9"
import script from "./PeopleRegistration.vue?vue&type=script&lang=js"
export * from "./PeopleRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports